<form [formGroup]="form" [id]="fieldName">
  @if (fieldName) {
    <div class="form-group flex flex-col grow align-content-center align-items-left items-center">
      <div>
        @if (lclAllowNull) {
          <p-checkbox
            [(ngModel)]="triStateValue"
            [ngModelOptions]="{ standalone: true }"
            [indeterminate]="this.triStateValue === null"
            [binary]="true"
          />
        } @else {
          <p-checkbox [inputId]="fieldName" [formControlName]="fieldName" [binary]="true" />
        }
        <label [for]="fieldName" class="ml-2" (click)="toggle()"> {{ label }} </label>
      </div>
      @if (isNull && lclAllowNull) {
        <small>{{ nullableLabel }}</small>
      }
      @if (displayHint) {
        <small class="block"> {{ displayHint }} </small>
      }
      @if (displayHint$) {
        <small class="block"> {{ displayHint$ | async }} </small>
      }
      <s-form-error-input
        [groupName]="groupName"
        [fieldName]="fieldName"
        [form]="form"
        [apiError]="apiError"
        [schema]="schema"
      />
    </div>
  }
</form>
